export const environment = {
  appVersion: require('../../package.json').version,
  production: true,
  firebaseConfig : {
    apiKey: "AIzaSyB0ccquEu8jKiWMkOsWyZLk172igdIvweI",
    authDomain: "dometest-8e92a.firebaseapp.com",
    projectId: "dometest-8e92a",
    storageBucket: "dometest-8e92a.appspot.com",
    messagingSenderId: "685680007920",
    appId: "1:685680007920:web:2fc10030d533ebbfb84035",
    measurementId: "G-VZRYZTFTLP"
  },
  baseUrl: "https://stag-app.gazookystudios.com",
  arUrl: "https://gallariewebar.web.app/?p=",
  appName: "Gazooky TimeWalks Stag",
  generatorUrl: "https://zptgenerator.sistibbards.repl.co",
  combinedAnalytics: "https://lookerstudio.google.com/s/u-HtZbJz8GI",
  showLogo: true,
  imageGen: true,
  uploadAnim: false,
  envfeatures : {
    Gallery: true, 
    Video: true, 
    Map: true, 
    Information: true, 
    Website: true, 
    Phone: true, 
    AR: true,
    Competition: true,
    GPS: true,
    Journey: true,
    AppStore: true,
    Interactive: true,
    InteractiveAR: true,
    Blog: true,
    Colour: true,
    Logo: true,
    Audio: true,
    Navigation: true,
  }
};

export const analyticsUrl = (analyticsId: string, id: string) => `https://lookerstudio.google.com/reporting/${analyticsId}/page/p_cajfki5ded?params=%7B%22ds28.experienceid%22:%22${id}%22,%22ds37.experienceid%22:%22${id}%22,%22ds13.experienceid%22:%22${id}%22%7D`;